import { render } from "./ModalExtratoConta.vue?vue&type=template&id=0b6c12c5&scoped=true"
import script from "./ModalExtratoConta.vue?vue&type=script&lang=js"
export * from "./ModalExtratoConta.vue?vue&type=script&lang=js"

import "./ModalExtratoConta.vue?vue&type=style&index=0&id=0b6c12c5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6c12c5"]])

export default __exports__